/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddBrokerToGroupContractCommand,
  AddTunnelToGroupContractCommand,
  AnimalContractDetails,
  ContractDetailsGlobal,
  CreateGroupContractCommand,
  ErrorResponse,
  GetAdminContractListResponse,
  GetContractDocumentsResponseDto,
  GetContractFilterResponseDto,
  GetContractGuaranteesResponseDto,
  GetContractQuotesResponseDto,
  GetFacetsResponse,
  GetGenericListCommandDto,
  GetGroupContractListResponse,
  GetGroupContractMandatsResponse,
  GetInsuredsResponseDto,
  GetPaymentsResponse,
  GetSummaryContractListResponse,
  GetSummaryContracts404Response,
  GroupContractDto,
  OperationResponse,
  OperationResponse1,
  SearchGroupContractMembersCommand,
  SearchGroupContractMembersResponse,
  SetSubscriberCommand,
  UpdateGroupContractCommand,
  UpdateGroupContractMandatsCommand,
} from '../models/index';
import {
    AddBrokerToGroupContractCommandFromJSON,
    AddBrokerToGroupContractCommandToJSON,
    AddTunnelToGroupContractCommandFromJSON,
    AddTunnelToGroupContractCommandToJSON,
    AnimalContractDetailsFromJSON,
    AnimalContractDetailsToJSON,
    ContractDetailsGlobalFromJSON,
    ContractDetailsGlobalToJSON,
    CreateGroupContractCommandFromJSON,
    CreateGroupContractCommandToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetAdminContractListResponseFromJSON,
    GetAdminContractListResponseToJSON,
    GetContractDocumentsResponseDtoFromJSON,
    GetContractDocumentsResponseDtoToJSON,
    GetContractFilterResponseDtoFromJSON,
    GetContractFilterResponseDtoToJSON,
    GetContractGuaranteesResponseDtoFromJSON,
    GetContractGuaranteesResponseDtoToJSON,
    GetContractQuotesResponseDtoFromJSON,
    GetContractQuotesResponseDtoToJSON,
    GetFacetsResponseFromJSON,
    GetFacetsResponseToJSON,
    GetGenericListCommandDtoFromJSON,
    GetGenericListCommandDtoToJSON,
    GetGroupContractListResponseFromJSON,
    GetGroupContractListResponseToJSON,
    GetGroupContractMandatsResponseFromJSON,
    GetGroupContractMandatsResponseToJSON,
    GetInsuredsResponseDtoFromJSON,
    GetInsuredsResponseDtoToJSON,
    GetPaymentsResponseFromJSON,
    GetPaymentsResponseToJSON,
    GetSummaryContractListResponseFromJSON,
    GetSummaryContractListResponseToJSON,
    GetSummaryContracts404ResponseFromJSON,
    GetSummaryContracts404ResponseToJSON,
    GroupContractDtoFromJSON,
    GroupContractDtoToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    OperationResponse1FromJSON,
    OperationResponse1ToJSON,
    SearchGroupContractMembersCommandFromJSON,
    SearchGroupContractMembersCommandToJSON,
    SearchGroupContractMembersResponseFromJSON,
    SearchGroupContractMembersResponseToJSON,
    SetSubscriberCommandFromJSON,
    SetSubscriberCommandToJSON,
    UpdateGroupContractCommandFromJSON,
    UpdateGroupContractCommandToJSON,
    UpdateGroupContractMandatsCommandFromJSON,
    UpdateGroupContractMandatsCommandToJSON,
} from '../models/index';

export interface AddBrokerToGroupContractRequest {
    groupContractId: string;
    addBrokerToGroupContractCommand: AddBrokerToGroupContractCommand;
}

export interface AddTunnelToGroupContractRequest {
    groupContractId: string;
    addTunnelToGroupContractCommand: AddTunnelToGroupContractCommand;
}

export interface CreateGroupContractRequest {
    createGroupContractCommand: CreateGroupContractCommand;
}

export interface GetAdminContractListFacetsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetAdminContractsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetAnimalContractDetailsRequest {
    contractId: string;
}

export interface GetContractListFacetsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetDocumentsRequest {
    contractId: string;
}

export interface GetGlobalContractDetailsRequest {
    contractId: string;
}

export interface GetGroupContractByIDRequest {
    groupContractId: string;
}

export interface GetGroupContractDocumentsRequest {
    groupContractId: string;
}

export interface GetGroupContractMandatsRequest {
    groupContractId: string;
}

export interface GetGroupContractsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetGroupContractsCourtierRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface GetGuaranteesRequest {
    contractId: string;
}

export interface GetInsuredsRequest {
    contractId: string;
}

export interface GetPaymentsRequest {
    contractId: string;
}

export interface GetQuotesRequest {
    contractId: string;
}

export interface GetSummaryContractsRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface PatchContractAnimationRequest {
    riskId: string;
}

export interface RemoveBrokerFromGroupContractRequest {
    groupContractId: string;
    brokerId: string;
}

export interface RemoveTunnelFromGroupContractRequest {
    groupContractId: string;
    tunnelId: string;
}

export interface SearchGroupContractMembersRequest {
    searchGroupContractMembersCommand: SearchGroupContractMembersCommand;
}

export interface SetGroupContractSubscriberRequest {
    groupContractId: string;
    setSubscriberCommand: SetSubscriberCommand;
}

export interface TriggerGroupContractSingleMandatSignatureRequest {
    groupContractId: string;
    mandatId: string;
}

export interface UpdateGroupContractRequest {
    groupContractId: string;
    updateGroupContractCommand: UpdateGroupContractCommand;
}

export interface UpdateGroupContractMandatsRequest {
    groupContractId: string;
    updateGroupContractMandatsCommand: UpdateGroupContractMandatsCommand;
}

/**
 * 
 */
export class ContractsApi extends runtime.BaseAPI {

    /**
     * Enable a broker on a group contract (admin only)
     */
    async addBrokerToGroupContractRaw(requestParameters: AddBrokerToGroupContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse1>> {
        if (requestParameters['groupContractId'] == null) {
            throw new runtime.RequiredError(
                'groupContractId',
                'Required parameter "groupContractId" was null or undefined when calling addBrokerToGroupContract().'
            );
        }

        if (requestParameters['addBrokerToGroupContractCommand'] == null) {
            throw new runtime.RequiredError(
                'addBrokerToGroupContractCommand',
                'Required parameter "addBrokerToGroupContractCommand" was null or undefined when calling addBrokerToGroupContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/contrats/groupes/{groupContractId}/courtiers`.replace(`{${"groupContractId"}}`, encodeURIComponent(String(requestParameters['groupContractId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddBrokerToGroupContractCommandToJSON(requestParameters['addBrokerToGroupContractCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponse1FromJSON(jsonValue));
    }

    /**
     * Enable a broker on a group contract (admin only)
     */
    async addBrokerToGroupContract(requestParameters: AddBrokerToGroupContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse1> {
        const response = await this.addBrokerToGroupContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a collective tunnel to a group contract
     */
    async addTunnelToGroupContractRaw(requestParameters: AddTunnelToGroupContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse1>> {
        if (requestParameters['groupContractId'] == null) {
            throw new runtime.RequiredError(
                'groupContractId',
                'Required parameter "groupContractId" was null or undefined when calling addTunnelToGroupContract().'
            );
        }

        if (requestParameters['addTunnelToGroupContractCommand'] == null) {
            throw new runtime.RequiredError(
                'addTunnelToGroupContractCommand',
                'Required parameter "addTunnelToGroupContractCommand" was null or undefined when calling addTunnelToGroupContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/contrats/groupes/{groupContractId}/tunnels`.replace(`{${"groupContractId"}}`, encodeURIComponent(String(requestParameters['groupContractId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddTunnelToGroupContractCommandToJSON(requestParameters['addTunnelToGroupContractCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponse1FromJSON(jsonValue));
    }

    /**
     * Add a collective tunnel to a group contract
     */
    async addTunnelToGroupContract(requestParameters: AddTunnelToGroupContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse1> {
        const response = await this.addTunnelToGroupContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a group contract
     */
    async createGroupContractRaw(requestParameters: CreateGroupContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createGroupContractCommand'] == null) {
            throw new runtime.RequiredError(
                'createGroupContractCommand',
                'Required parameter "createGroupContractCommand" was null or undefined when calling createGroupContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/contrats/groupes/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateGroupContractCommandToJSON(requestParameters['createGroupContractCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create a group contract
     */
    async createGroupContract(requestParameters: CreateGroupContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createGroupContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Facettes de la liste admin des contrats, avec les dimensions plateformes et courtiers. Permission BackOffice.AdminContrats.Read (403 sinon). 
     * Get admin contract list facets (BO admin)
     */
    async getAdminContractListFacetsRaw(requestParameters: GetAdminContractListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacetsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminContractListFacets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/contrats/admin/liste/filtres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacetsResponseFromJSON(jsonValue));
    }

    /**
     * Facettes de la liste admin des contrats, avec les dimensions plateformes et courtiers. Permission BackOffice.AdminContrats.Read (403 sinon). 
     * Get admin contract list facets (BO admin)
     */
    async getAdminContractListFacets(requestParameters: GetAdminContractListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacetsResponse> {
        const response = await this.getAdminContractListFacetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Liste admin paginée des contrats, toutes plateformes. Items enrichis de brokerId/brokerName et plateformeId/plateformeName. filters.plateformeIds et filters.brokerIds disponibles (brokerIds seul remonte tous les dossiers du courtier, même multi-plateformes). Permission BackOffice.AdminContrats.Read (403 sinon). Remplace /api/backoffice/contrats/liste-global. 
     * Get contracts, all plateformes (BO admin)
     */
    async getAdminContractsRaw(requestParameters: GetAdminContractsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAdminContractListResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getAdminContracts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/contrats/admin/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAdminContractListResponseFromJSON(jsonValue));
    }

    /**
     * Liste admin paginée des contrats, toutes plateformes. Items enrichis de brokerId/brokerName et plateformeId/plateformeName. filters.plateformeIds et filters.brokerIds disponibles (brokerIds seul remonte tous les dossiers du courtier, même multi-plateformes). Permission BackOffice.AdminContrats.Read (403 sinon). Remplace /api/backoffice/contrats/liste-global. 
     * Get contracts, all plateformes (BO admin)
     */
    async getAdminContracts(requestParameters: GetAdminContractsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAdminContractListResponse> {
        const response = await this.getAdminContractsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get animal details of a pet insurance contract
     */
    async getAnimalContractDetailsRaw(requestParameters: GetAnimalContractDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnimalContractDetails>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getAnimalContractDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/contrats/{contractId}/animal`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnimalContractDetailsFromJSON(jsonValue));
    }

    /**
     * Get animal details of a pet insurance contract
     */
    async getAnimalContractDetails(requestParameters: GetAnimalContractDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnimalContractDetails> {
        const response = await this.getAnimalContractDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contract filters
     */
    async getContractFiltersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContractFilterResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/contrats/filters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContractFilterResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get contract filters
     */
    async getContractFilters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContractFilterResponseDto> {
        const response = await this.getContractFiltersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Facettes du panneau de filtres de la liste des contrats (espace courtier). Envoyer les filtres courants dans le body : les options d\'une dimension sont calculées avec tous les filtres sauf celui de la dimension elle-même. À rappeler à l\'ouverture du panneau et à chaque changement de filtre ou de searchString (debounce ~300 ms) — pas au changement de page. 
     * Get contract list facets (courtier)
     */
    async getContractListFacetsRaw(requestParameters: GetContractListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFacetsResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getContractListFacets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/contrats/liste/filtres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFacetsResponseFromJSON(jsonValue));
    }

    /**
     * Facettes du panneau de filtres de la liste des contrats (espace courtier). Envoyer les filtres courants dans le body : les options d\'une dimension sont calculées avec tous les filtres sauf celui de la dimension elle-même. À rappeler à l\'ouverture du panneau et à chaque changement de filtre ou de searchString (debounce ~300 ms) — pas au changement de page. 
     * Get contract list facets (courtier)
     */
    async getContractListFacets(requestParameters: GetContractListFacetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFacetsResponse> {
        const response = await this.getContractListFacetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contract documents list by contract ID
     */
    async getDocumentsRaw(requestParameters: GetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContractDocumentsResponseDto>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/contrats/{contractId}/documents`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContractDocumentsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get contract documents list by contract ID
     */
    async getDocuments(requestParameters: GetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContractDocumentsResponseDto> {
        const response = await this.getDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get global contract informations by ID
     */
    async getGlobalContractDetailsRaw(requestParameters: GetGlobalContractDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractDetailsGlobal>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getGlobalContractDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/contrats/{contractId}/general`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractDetailsGlobalFromJSON(jsonValue));
    }

    /**
     * Get global contract informations by ID
     */
    async getGlobalContractDetails(requestParameters: GetGlobalContractDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractDetailsGlobal> {
        const response = await this.getGlobalContractDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get group contract by ID
     */
    async getGroupContractByIDRaw(requestParameters: GetGroupContractByIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupContractDto>> {
        if (requestParameters['groupContractId'] == null) {
            throw new runtime.RequiredError(
                'groupContractId',
                'Required parameter "groupContractId" was null or undefined when calling getGroupContractByID().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/contrats/groupes/{groupContractId}`.replace(`{${"groupContractId"}}`, encodeURIComponent(String(requestParameters['groupContractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupContractDtoFromJSON(jsonValue));
    }

    /**
     * Get group contract by ID
     */
    async getGroupContractByID(requestParameters: GetGroupContractByIDRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupContractDto> {
        const response = await this.getGroupContractByIDRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Documents du contrat collectif : contrat généré/signé (DocumentContrat) et documents produit (variante groupe) des tunnels actifs. Même garde de périmètre que le détail du contrat de groupe. 
     * Get group contract documents list by group contract ID
     */
    async getGroupContractDocumentsRaw(requestParameters: GetGroupContractDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContractDocumentsResponseDto>> {
        if (requestParameters['groupContractId'] == null) {
            throw new runtime.RequiredError(
                'groupContractId',
                'Required parameter "groupContractId" was null or undefined when calling getGroupContractDocuments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/contrats/groupes/{groupContractId}/documents`.replace(`{${"groupContractId"}}`, encodeURIComponent(String(requestParameters['groupContractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContractDocumentsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Documents du contrat collectif : contrat généré/signé (DocumentContrat) et documents produit (variante groupe) des tunnels actifs. Même garde de périmètre que le détail du contrat de groupe. 
     * Get group contract documents list by group contract ID
     */
    async getGroupContractDocuments(requestParameters: GetGroupContractDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContractDocumentsResponseDto> {
        const response = await this.getGroupContractDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get SEPA mandates state for a group contract
     */
    async getGroupContractMandatsRaw(requestParameters: GetGroupContractMandatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGroupContractMandatsResponse>> {
        if (requestParameters['groupContractId'] == null) {
            throw new runtime.RequiredError(
                'groupContractId',
                'Required parameter "groupContractId" was null or undefined when calling getGroupContractMandats().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/contrats/groupes/{groupContractId}/mandat`.replace(`{${"groupContractId"}}`, encodeURIComponent(String(requestParameters['groupContractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGroupContractMandatsResponseFromJSON(jsonValue));
    }

    /**
     * Get SEPA mandates state for a group contract
     */
    async getGroupContractMandats(requestParameters: GetGroupContractMandatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGroupContractMandatsResponse> {
        const response = await this.getGroupContractMandatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get group contracts
     */
    async getGroupContractsRaw(requestParameters: GetGroupContractsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGroupContractListResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getGroupContracts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/contrats/groupes/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGroupContractListResponseFromJSON(jsonValue));
    }

    /**
     * Get group contracts
     */
    async getGroupContracts(requestParameters: GetGroupContractsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGroupContractListResponse> {
        const response = await this.getGroupContractsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the group contracts (contrats collectifs) of the connected broker. The broker is auto-resolved server-side from the auth context. Filters by: broker is the creator OR is an active habilitated broker. 
     * Get group contracts of the connected broker
     */
    async getGroupContractsCourtierRaw(requestParameters: GetGroupContractsCourtierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGroupContractListResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getGroupContractsCourtier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/contrats/groupes/courtier/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGroupContractListResponseFromJSON(jsonValue));
    }

    /**
     * Returns the group contracts (contrats collectifs) of the connected broker. The broker is auto-resolved server-side from the auth context. Filters by: broker is the creator OR is an active habilitated broker. 
     * Get group contracts of the connected broker
     */
    async getGroupContractsCourtier(requestParameters: GetGroupContractsCourtierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGroupContractListResponse> {
        const response = await this.getGroupContractsCourtierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contract guarantees list by contract ID
     */
    async getGuaranteesRaw(requestParameters: GetGuaranteesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContractGuaranteesResponseDto>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getGuarantees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/contrats/{contractId}/garanties`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContractGuaranteesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get contract guarantees list by contract ID
     */
    async getGuarantees(requestParameters: GetGuaranteesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContractGuaranteesResponseDto> {
        const response = await this.getGuaranteesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contract insureds informations by contract ID
     */
    async getInsuredsRaw(requestParameters: GetInsuredsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInsuredsResponseDto>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getInsureds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/contrats/{contractId}/assures`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInsuredsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get contract insureds informations by contract ID
     */
    async getInsureds(requestParameters: GetInsuredsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInsuredsResponseDto> {
        const response = await this.getInsuredsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get payments by contract Id
     */
    async getPaymentsRaw(requestParameters: GetPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPaymentsResponse>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getPayments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/contrats/{contractId}/echeances-paiement`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPaymentsResponseFromJSON(jsonValue));
    }

    /**
     * Get payments by contract Id
     */
    async getPayments(requestParameters: GetPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPaymentsResponse> {
        const response = await this.getPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contract quotes list by contract ID
     */
    async getQuotesRaw(requestParameters: GetQuotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetContractQuotesResponseDto>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getQuotes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/contrats/{contractId}/devis`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetContractQuotesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get contract quotes list by contract ID
     */
    async getQuotes(requestParameters: GetQuotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetContractQuotesResponseDto> {
        const response = await this.getQuotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contracts
     */
    async getSummaryContractsRaw(requestParameters: GetSummaryContractsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSummaryContractListResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling getSummaryContracts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/contrats/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSummaryContractListResponseFromJSON(jsonValue));
    }

    /**
     * Get contracts
     */
    async getSummaryContracts(requestParameters: GetSummaryContractsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSummaryContractListResponse> {
        const response = await this.getSummaryContractsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch contract animation
     */
    async patchContractAnimationRaw(requestParameters: PatchContractAnimationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['riskId'] == null) {
            throw new runtime.RequiredError(
                'riskId',
                'Required parameter "riskId" was null or undefined when calling patchContractAnimation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/contrats/risques/{riskId}/animation`.replace(`{${"riskId"}}`, encodeURIComponent(String(requestParameters['riskId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Patch contract animation
     */
    async patchContractAnimation(requestParameters: PatchContractAnimationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.patchContractAnimationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Disable a broker from a group contract (admin only)
     */
    async removeBrokerFromGroupContractRaw(requestParameters: RemoveBrokerFromGroupContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse1>> {
        if (requestParameters['groupContractId'] == null) {
            throw new runtime.RequiredError(
                'groupContractId',
                'Required parameter "groupContractId" was null or undefined when calling removeBrokerFromGroupContract().'
            );
        }

        if (requestParameters['brokerId'] == null) {
            throw new runtime.RequiredError(
                'brokerId',
                'Required parameter "brokerId" was null or undefined when calling removeBrokerFromGroupContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/contrats/groupes/{groupContractId}/courtiers/{brokerId}`.replace(`{${"groupContractId"}}`, encodeURIComponent(String(requestParameters['groupContractId']))).replace(`{${"brokerId"}}`, encodeURIComponent(String(requestParameters['brokerId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponse1FromJSON(jsonValue));
    }

    /**
     * Disable a broker from a group contract (admin only)
     */
    async removeBrokerFromGroupContract(requestParameters: RemoveBrokerFromGroupContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse1> {
        const response = await this.removeBrokerFromGroupContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a tunnel from a group contract (deactivation)
     */
    async removeTunnelFromGroupContractRaw(requestParameters: RemoveTunnelFromGroupContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse1>> {
        if (requestParameters['groupContractId'] == null) {
            throw new runtime.RequiredError(
                'groupContractId',
                'Required parameter "groupContractId" was null or undefined when calling removeTunnelFromGroupContract().'
            );
        }

        if (requestParameters['tunnelId'] == null) {
            throw new runtime.RequiredError(
                'tunnelId',
                'Required parameter "tunnelId" was null or undefined when calling removeTunnelFromGroupContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/contrats/groupes/{groupContractId}/tunnels/{tunnelId}`.replace(`{${"groupContractId"}}`, encodeURIComponent(String(requestParameters['groupContractId']))).replace(`{${"tunnelId"}}`, encodeURIComponent(String(requestParameters['tunnelId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponse1FromJSON(jsonValue));
    }

    /**
     * Remove a tunnel from a group contract (deactivation)
     */
    async removeTunnelFromGroupContract(requestParameters: RemoveTunnelFromGroupContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse1> {
        const response = await this.removeTunnelFromGroupContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Monitoring view: which members can be debited, and which are blocked.
     * Search group contracts with their members and direct-debit state
     */
    async searchGroupContractMembersRaw(requestParameters: SearchGroupContractMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchGroupContractMembersResponse>> {
        if (requestParameters['searchGroupContractMembersCommand'] == null) {
            throw new runtime.RequiredError(
                'searchGroupContractMembersCommand',
                'Required parameter "searchGroupContractMembersCommand" was null or undefined when calling searchGroupContractMembers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/contrats/groupes/aliments/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchGroupContractMembersCommandToJSON(requestParameters['searchGroupContractMembersCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchGroupContractMembersResponseFromJSON(jsonValue));
    }

    /**
     * Monitoring view: which members can be debited, and which are blocked.
     * Search group contracts with their members and direct-debit state
     */
    async searchGroupContractMembers(requestParameters: SearchGroupContractMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchGroupContractMembersResponse> {
        const response = await this.searchGroupContractMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set the subscriber of a group contract
     */
    async setGroupContractSubscriberRaw(requestParameters: SetGroupContractSubscriberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse1>> {
        if (requestParameters['groupContractId'] == null) {
            throw new runtime.RequiredError(
                'groupContractId',
                'Required parameter "groupContractId" was null or undefined when calling setGroupContractSubscriber().'
            );
        }

        if (requestParameters['setSubscriberCommand'] == null) {
            throw new runtime.RequiredError(
                'setSubscriberCommand',
                'Required parameter "setSubscriberCommand" was null or undefined when calling setGroupContractSubscriber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/contrats/groupes/{groupContractId}/souscripteur`.replace(`{${"groupContractId"}}`, encodeURIComponent(String(requestParameters['groupContractId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetSubscriberCommandToJSON(requestParameters['setSubscriberCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponse1FromJSON(jsonValue));
    }

    /**
     * Set the subscriber of a group contract
     */
    async setGroupContractSubscriber(requestParameters: SetGroupContractSubscriberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse1> {
        const response = await this.setGroupContractSubscriberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generates (or refreshes) the Epithete token for the given mandate and sends a signature email to the subscriber. Useful for both the initial individual request and resending. 
     * Trigger SEPA signature workflow for a single mandate of a group contract
     */
    async triggerGroupContractSingleMandatSignatureRaw(requestParameters: TriggerGroupContractSingleMandatSignatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse1>> {
        if (requestParameters['groupContractId'] == null) {
            throw new runtime.RequiredError(
                'groupContractId',
                'Required parameter "groupContractId" was null or undefined when calling triggerGroupContractSingleMandatSignature().'
            );
        }

        if (requestParameters['mandatId'] == null) {
            throw new runtime.RequiredError(
                'mandatId',
                'Required parameter "mandatId" was null or undefined when calling triggerGroupContractSingleMandatSignature().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/contrats/groupes/{groupContractId}/mandat/{mandatId}/signature`.replace(`{${"groupContractId"}}`, encodeURIComponent(String(requestParameters['groupContractId']))).replace(`{${"mandatId"}}`, encodeURIComponent(String(requestParameters['mandatId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponse1FromJSON(jsonValue));
    }

    /**
     * Generates (or refreshes) the Epithete token for the given mandate and sends a signature email to the subscriber. Useful for both the initial individual request and resending. 
     * Trigger SEPA signature workflow for a single mandate of a group contract
     */
    async triggerGroupContractSingleMandatSignature(requestParameters: TriggerGroupContractSingleMandatSignatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse1> {
        const response = await this.triggerGroupContractSingleMandatSignatureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a group contract
     */
    async updateGroupContractRaw(requestParameters: UpdateGroupContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse1>> {
        if (requestParameters['groupContractId'] == null) {
            throw new runtime.RequiredError(
                'groupContractId',
                'Required parameter "groupContractId" was null or undefined when calling updateGroupContract().'
            );
        }

        if (requestParameters['updateGroupContractCommand'] == null) {
            throw new runtime.RequiredError(
                'updateGroupContractCommand',
                'Required parameter "updateGroupContractCommand" was null or undefined when calling updateGroupContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/contrats/groupes/{groupContractId}/update`.replace(`{${"groupContractId"}}`, encodeURIComponent(String(requestParameters['groupContractId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateGroupContractCommandToJSON(requestParameters['updateGroupContractCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponse1FromJSON(jsonValue));
    }

    /**
     * Update a group contract
     */
    async updateGroupContract(requestParameters: UpdateGroupContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse1> {
        const response = await this.updateGroupContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolves 1 mandate per unique (debtor IBAN, creditor IBAN) pair across active tunnels. Multiple tunnels with the same creditor share the same Mandat. Locked once any mandate is signed or the contract is finalized. 
     * Update the bank account / mandate config of a group contract
     */
    async updateGroupContractMandatsRaw(requestParameters: UpdateGroupContractMandatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse1>> {
        if (requestParameters['groupContractId'] == null) {
            throw new runtime.RequiredError(
                'groupContractId',
                'Required parameter "groupContractId" was null or undefined when calling updateGroupContractMandats().'
            );
        }

        if (requestParameters['updateGroupContractMandatsCommand'] == null) {
            throw new runtime.RequiredError(
                'updateGroupContractMandatsCommand',
                'Required parameter "updateGroupContractMandatsCommand" was null or undefined when calling updateGroupContractMandats().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/contrats/groupes/{groupContractId}/mandat`.replace(`{${"groupContractId"}}`, encodeURIComponent(String(requestParameters['groupContractId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateGroupContractMandatsCommandToJSON(requestParameters['updateGroupContractMandatsCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponse1FromJSON(jsonValue));
    }

    /**
     * Resolves 1 mandate per unique (debtor IBAN, creditor IBAN) pair across active tunnels. Multiple tunnels with the same creditor share the same Mandat. Locked once any mandate is signed or the contract is finalized. 
     * Update the bank account / mandate config of a group contract
     */
    async updateGroupContractMandats(requestParameters: UpdateGroupContractMandatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse1> {
        const response = await this.updateGroupContractMandatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
